/* DOM 元素快取 —— 三個接縫之一。

   為什麼要延後初始化：原本是在模組載入時就 document.getElementById，
   於是整個 main.ts 只要被 import 就需要一個真實的 DOM，Node 裡連載入都會炸，
   重播測試因此只能開真瀏覽器跑。

   現在改成「宣告時是 null，由 initDom() 或 initDomHeadless() 填值」。
   ES 模組的匯出是活繫結（live binding），所以 main.ts 那 50 幾處
   `elHpFill.style.width = ...` 一行都不用改，初始化之後就會看到真正的元素。 */

export var $: (id: string) => any = function () { return null; };

export var elStage: any = null, elFx: any = null;
export var elTime: any = null, elLv: any = null;
export var elHpFill: any = null, elShFill: any = null, elHpTxt: any = null;
export var elThFill: any = null, elThTrack: any = null;
export var elKills: any = null, elStageName: any = null, elRev: any = null;
export var elBoss: any = null, elSlots: any = null, elPrompt: any = null;
export var elStart: any = null, elOver: any = null, elUp: any = null, elRw: any = null;
export var skillEls: any = null;

/** headless 用的空元素：所有讀寫都吞掉，永遠不丟例外。 */
export function stubEl(): any {
  return {
    className: '', textContent: '', innerHTML: '', value: '', offsetWidth: 0, offsetHeight: 0,
    style: {},
    classList: { add() {}, remove() {}, toggle() {}, contains() { return false; } },
    appendChild(c: any) { return c; },
    removeChild(c: any) { return c; },
    addEventListener() {},
    removeEventListener() {},
    setAttribute() {},
    getAttribute() { return null; },
    querySelector() { return null; },
    querySelectorAll() { return [] as any[]; },
    getBoundingClientRect() { return { left: 0, top: 0, width: 0, height: 0 }; },
  };
}

function assign(get: (id: string) => any) {
  $ = get;
  elStage = get('stage'); elFx = get('fxLayer');
  elTime = get('hudTime'); elLv = get('hudLv');
  elHpFill = get('hpFill'); elShFill = get('shFill'); elHpTxt = get('hpTxt');
  elThFill = get('thFill'); elThTrack = get('thTrack');
  elKills = get('hudKills'); elStageName = get('hudStage'); elRev = get('hudRev');
  elBoss = get('bossBar'); elSlots = get('slots'); elPrompt = get('prompt');
  elStart = get('screenStart'); elOver = get('screenOver'); elUp = get('screenUp'); elRw = get('screenReward');
  skillEls = {
    dash: { root: get('skDash'), fill: get('skDashFill'), n: get('skDashN'), ico: get('skDashI') },
    mid: { root: get('skMid'), fill: get('skMidFill'), n: get('skMidN'), ico: get('skMidI') },
    ult: { root: get('skUlt'), fill: get('skUltFill'), n: get('skUltN'), ico: get('skUltI') }
  };
}

/** 瀏覽器：抓真實元素。index.html 的 script 是 type=module（自動 defer），DOM 保證已就緒。 */
export function initDom() {
  assign(function (id) { return document.getElementById(id); });
}

/** headless：每個 id 給一個獨立的空元素。 */
export function initDomHeadless() {
  var cache: Record<string, any> = {};
  assign(function (id) { return (cache[id] || (cache[id] = stubEl())); });
}
